import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../../shared/shared.module';
import { ButtonModule } from 'src/app/shared/form/button/button.module';
import { MiniGamesEditorComponent } from './mini-games-editor.component';
import { TextareaModule } from 'src/app/shared/form/textarea/textarea.module';
import { TextfieldComponent } from 'src/app/shared/form/textfield/textfield.component';
import { ContentPickerModule } from 'src/app/shared/form/content-picker/content-picker.module';
import { TagfieldModule } from 'src/app/shared/form/tagfield/tagfield.module';
import { SelectModule } from 'src/app/shared/form/select/select.module';

@NgModule({
    declarations: [
        MiniGamesEditorComponent
    ],
    imports: [
        FormsModule,
        SharedModule,
        CommonModule,
        RouterModule,
        ButtonModule,
        SelectModule,
        TextareaModule,
        TagfieldModule,
        TextfieldComponent,
        ContentPickerModule,
    ],
})
export class MiniGamesEditorModule { }